import { useCallback, useState } from "react";

import { loadDetailViewMode, saveDetailViewMode, type DetailViewMode } from "@/lib/detailViewMode";

// The detail panel's presentation preference (⑤: "dock" vs "large"), persisted per user
// and shared across boards + views. Mirrors useDetailPaneRatio.
export function useDetailViewMode() {
  const [mode, setModeState] = useState<DetailViewMode>(loadDetailViewMode);
  const setMode = useCallback((m: DetailViewMode) => {
    setModeState(m);
    saveDetailViewMode(m);
  }, []);
  return [mode, setMode] as const;
}
